import React from 'react';
import PropTypes from 'prop-types';

import SwatchDropdown from '../SwatchDropdown/SwatchDropdown';
import Radio from '../Radio/Radio';
import { StyledUl } from './RadioListStyles';

var RadioList = function RadioList(props) {
  var useSwatch = props.option.name.toLowerCase() == 'color';
  var RadioType = props.useDropdown ? 'DROPDOWN' : useSwatch ? 'SWATCH' : 'BUTTON';
  return React.createElement(
    StyledUl,
    {
      radioType: RadioType,
      dropdownActive: props.dropdownActive,
      parent: props.parent
    },
    props.option.values.map(function (value) {
      return React.createElement(Radio, {
        key: value,
        handleOptionChange: props.handleOptionChange,
        name: props.option.name,
        value: value,
        checked: props.selectedOptions[props.option.name] === value,
        variants: props.variants,
        selectedOptions: props.selectedOptions,
        productId: props.productId,
        useDropdown: props.useDropdown,
        dropdownActive: props.dropdownActive,
        radioType: RadioType,
        parent: props.parent || 'RadioList'
      });
    }),
    props.option.values.length > 4 && props.parent == 'CollectionCard__swatch-container' && React.createElement(
      'li',
      null,
      React.createElement(SwatchDropdown, props)
    )
  );
};

RadioList.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  option: PropTypes.object,
  productId: PropTypes.string.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  selectedVariant: PropTypes.object,
  selectedVariantQuantity: PropTypes.number,
  useDropdown: PropTypes.bool,
  variants: PropTypes.array.isRequired,
  parent: PropTypes.string,
  dropdownActive: PropTypes.bool
};

export default React.memo(RadioList);